var map = {
	"./AUCHAN/logo.png": "qzEC",
	"./AUTOSPHERE/logo.png": "M+P0",
	"./AXAMAMAISON/logo.png": "e7Gu",
	"./BALTUS/logo.png": "yMOq",
	"./CAROUSEL/logo.png": "52CO",
	"./DIAKSE/logo.png": "WJZI",
	"./MERCUREROISSY/logo.png": "m03+",
	"./NOVOTELBERCY/logo.png": "SzEU"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "p8x8";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\/logo\.png$
// module id = p8x8
// module chunks = 1